// extracted by mini-css-extract-plugin
export default {"table":"vp_oAvQS"};